import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CheckInType, OrderCheckInRequest } from '@app/core/redux/stores';
import { CheckInService } from '@features/ordering/services/checkin.service';

@Component({
  selector: 'app-curbside-nospace',
  templateUrl: './curbside-nospace.component.html',
  styleUrls: ['./curbside-nospace.component.less']
})
export class CurbsideNospaceComponent implements OnInit {
  checkInNoSpaceFormGroup: UntypedFormGroup;
  loading = false;
  constructor(public curbside: CheckInService, private fb: UntypedFormBuilder) {
   }
  ngOnInit(): void {
    this.createCheckInNoSpaceForm();
  }
  createCheckInNoSpaceForm() {
    this.checkInNoSpaceFormGroup = this.fb.group({
      vehicleType: ['', [Validators.required]],
      vehicleColor: ['', [Validators.required]]     
    });
  }
  checkInNoSpace() {
    const orderCheckInRequest: OrderCheckInRequest = {
      checkInIndicator : null, checkInType : CheckInType.Curbside};
    this.curbside.checkIn(orderCheckInRequest);
  }
  submitCheckInNoSpaceForm() {
    this.loading = true;
    if(this.checkInNoSpaceFormGroup.invalid) {
      this.checkInNoSpaceFormGroup.setErrors(this.checkInNoSpaceFormGroup.errors);
      this.loading = false;
      return;
    }
    const data = this.checkInNoSpaceFormGroup.value;
    const orderCheckInRequest: OrderCheckInRequest = {
      checkInIndicator : null, checkInType : CheckInType.Curbside, checkInVehicleDetails: {
        vehicleColorId: data.vehicleColor,
        vehicleTypeId: data.vehicleType
      }};
      this.curbside.checkIn(orderCheckInRequest);
  }
}
